/* apps/viewer/src/app/toc-items/historic-module/navigation-tree/navigation-tree.component.scss */
:host {
  width: 100%;
}
ul,
#history-list {
  list-style-type: none;
}
#history-list {
  margin: 0;
  padding: 0;
}
#history-list li {
  cursor: default;
}
#history-list li .nested {
  display: none;
}
#history-list li .hide {
  visibility: hidden;
}
#history-list li .mat-icon,
#history-list li o-orion-card {
  cursor: pointer;
}
#history-list li .active {
  display: block;
}
#history-list li .row {
  align-items: center;
  display: flex;
  flex-direction: row;
}
#history-list li .row .item {
  margin: 8px;
  width: 100%;
}
#history-list li .row .item ::ng-deep .mat-mdc-card {
  margin: 0;
}
.selected-node {
  cursor: default !important;
}
/*# sourceMappingURL=navigation-tree.component.css.map */
